import { EMPTY_STRING } from "commons/constants"
import { API_URL } from 'config/config';
export const ROUTE = {
    GET_POSTCODE_SEARCH: '/ooh/filter/audience/postcode'
}

export const AUTH ={
    OKTA_URL: `/api/user/sso/authUrl?provider=okta`
}
export const INSIGHTS = {
    GET_PHOTO_GALLERY: (planId = "planId", mediaOwnerId = EMPTY_STRING) => `ooh/plan/${planId}/media-owner/${mediaOwnerId}`,
    MEDIA_OWNER_LEVEL: (planId) => `ooh/plan/${planId}/media-owner`
}

export const REPORT = {
    PUT_REPORT: (pixelId='PUT_REPORT') => `pixel/billboard/${pixelId}/enable`,
    GET_BILBOARD_EXCEL:(pixelId='GET_BILBOARD_EXCEL') => `${API_URL}/attr/billboard/${pixelId}/export/excel`,
    GET_PLAN_SCREEN_DETAIL_REPORT:(plan_id) => `${API_URL}/screeniq/excel/report/plan-screen-detail-report?planId=${plan_id}`,
    GET_PLAN_DOWNLOAD:(planId) => `${API_URL}/screeniq/excel/report/plan-download?planId=${planId}`,
    GET_PLAN_DOWNLOAD_STATUS:(planId) => `${API_URL}/screeniq/excel/report/plan-download/status?planId=${planId}`,
    GET_LIFT_STUDY_MONTHLY: (pixelId='GET_LIFT_STUDY_MONTHLY') => `lift-study/monthly/${pixelId}`,
    GET_LIFT_STUDY_CREATIVE: (pixelId='GET_LIFT_STUDY_CREATIVE') => `lift-study/creative/${pixelId}`,
    GET_LIFT_STUDY_CUMULATIVE: (pixelId='GET_LIFT_STUDY_CUMULATIVE') => `lift-study/cumulative/${pixelId}`
}
